// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"f5490bb6","498":"c3ef67fa","703":"8992627d","787":"a1ce374f"}[chunkId] + ".chunk.js";
};